import { InjectionToken } from '@angular/core';

export interface FeaturesConfig {
  [featureName: string]: boolean;
}

export const FEATURES_CONFIG: InjectionToken<FeaturesConfig> = new InjectionToken<FeaturesConfig>(
  'starfish-access-ui-features-config'
);
